import { Component, EventEmitter, Input, OnInit, OnChanges, Output, ViewChild, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { IndividualAcreagesDto, LessorInfoDto, LessorRepTypeDto, TerrainDto, MeasureDto, LandTitleDto } from '@cradua/data';
import Swal from 'sweetalert2';
import { IndividualAcreagesTableComponent } from './individual-acreages-table/individual-acreages-table.component';

@Component({
  selector: 'cradua-individual-acreages',
  templateUrl: './individual-acreages.component.html',
  styleUrls: ['./individual-acreages.component.scss']
})
export class IndividualAcreagesComponent implements OnChanges {

  @Input() selectedLessorInfo: LessorInfoDto;
  @Input() terrains: TerrainDto[];
  @Input() measures: MeasureDto[];
  @Input() selectedLandTitle: LandTitleDto;
  @Input() isLoadingIndividualAcreages: boolean;
  @Input() individualAcreages: IndividualAcreagesDto[];
  @Output() emitIndividualAcreages = new EventEmitter<any>();
  @Output() emitIndividualAcreagesDelete = new EventEmitter<any>();
  @Output() emitTask = new EventEmitter<any>();
  @ViewChild(IndividualAcreagesTableComponent) child: IndividualAcreagesTableComponent;
  individualAcreagesForm: FormGroup;
  selectedIndex = null;

  constructor(private fb: FormBuilder) { }

  ngOnChanges(change: SimpleChanges): void {
    this.createIndividualAcreagesForm();
  }

  createIndividualAcreagesForm() {
    this.individualAcreagesForm = this.fb.group({
      TerrainId: null,
      NetArea: null,
      MeasureId: null,
      Remarks: null,
      AddressBookId: null,
      LessorsId: null,
      LandTitleId: null,
    });

  }

  onEdit(value: IndividualAcreagesDto) {
    this.selectedIndex = value['index'];
    this.individualAcreagesForm.patchValue(value);
  }

  addNew(formValue: IndividualAcreagesDto) {
   let foundAcreages: IndividualAcreagesDto[] = [];
    if(this.individualAcreagesForm.invalid) {
   return Swal.fire(
      'Warning!',
      'Please, you cannot add blank field',
      'warning'
    );
    }
    foundAcreages = this.child.individualAcreagesArrayForm.value['IndividualAcreages'];


    if(this.selectedIndex != null) {

      let sumAssign = 0;
      let mergeIndArray = [];
      if((foundAcreages != null && foundAcreages.length) || (formValue != null)) {
        this.child.individualAcreagesFormArray['controls'][this.selectedIndex].patchValue(formValue)
       mergeIndArray =  this.child.individualAcreagesArrayForm.value['IndividualAcreages'];
         sumAssign = mergeIndArray
        .map((item) => item.NetArea)
        .reduce((prev, next) => prev + next);
      }

      if(sumAssign > this.selectedLandTitle.RecTotalArea) {
        sumAssign = 0;
        this.child.individualAcreagesFormArray['controls'][this.selectedIndex].patchValue({NetArea: 0})
        return Swal.fire(
          'Warning!',
          'Please, assigned area cannot be greater than total area',
          'warning'
        );
      }

      this.child.individualAcreagesFormArray['controls'][this.selectedIndex].patchValue(formValue);
    } else {
      let sumAssign = 0;
      let mergeIndArray = [];

      if((foundAcreages != null && foundAcreages.length) || (formValue != null)) {
       mergeIndArray =  [formValue, ...foundAcreages]
         sumAssign = mergeIndArray
        .map((item) => item.NetArea)
        .reduce((prev, next) => prev + next);
      }
      if(sumAssign > this.selectedLandTitle.RecTotalArea) {
        sumAssign = 0;
        return Swal.fire(
          'Warning!',
          'Please, assigned area cannot be greater than total area',
          'warning'
        );
      }
        this.child.addIndividualAcreages(formValue);


    }
    this.selectedIndex = null;
    this.individualAcreagesForm.reset();
  }

  onSubmit(){
    this.emitIndividualAcreages.emit(this.child.individualAcreagesArrayForm.value['IndividualAcreages']);
    if(this.child.filteredDelete.length > 0) {
      this.emitIndividualAcreagesDelete.emit(this.child.filteredDelete);
    }

  }

  onReset() {
    this.individualAcreagesForm.reset();
    this.selectedIndex = null;
  }

  onBack() {
    this.emitTask.emit('list');
  }

}
